import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PERM_CODE, routeMap } from '../constants/PermissionCodes';

const ProtectedRoute = ({ children }) => {
    const { user } = useSelector((state) => state.auth);
    const privilegeCodes = user?.privilege?.map((p) => p.privilegeCode) || [];
    const location = useLocation();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    const getDefaultAccessibleRoute = (privilegeCodes) => {
        const first = routeMap.find((r) => privilegeCodes.includes(r.code));
        return first?.path || "/unauthorized";
    };

    if (location.pathname === "/" || location.pathname === "/enquiry-management") {
        const hasAccess = privilegeCodes.includes(PERM_CODE.EMACC);
        if (!hasAccess) {
            return <Navigate to={getDefaultAccessibleRoute(privilegeCodes)} replace />;
        }
    }


    return children;
};

export default ProtectedRoute;
